import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled, thd, th } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';

import { withSettings } from 'containers/WebApp/SettingsContext';
import { trailingSlashIt } from '_platform/src/utils/utilities';

import FooterLogo from 'theme/logo-hp.svg';

const FooterWrapper = styled.footer`
  background-color: ${th('primary')};
  border-top: 8px solid ${thd('secondary', 'gold')};
`;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 2rem 0 2rem 0;
  ${up(
    'md',
    css`
      flex-direction: row;
      justify-content: space-between;
    `
  )};
  .logo {
    width: 75px;
    height: 75px;
  }
  p {
    color: #fff;
    font-size: 16px;
  }
  ul {
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${up(
      'md',
      css`
        flex-direction: row;
      `
    )};
  }
  li {
    font-size: 16px;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    ${up(
      'md',
      css`
        border-right: 1px solid #fff;
        padding: inherit;
        text-align: left;
        &:nth-last-child(1) {
          border-right: none;
        }
      `
    )};
    a {
      color: #fff;
      text-decoration: none;
      padding: 0.1rem 1rem;
      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }

  .footer-right-text {
    padding: 0 1rem;
  }
`;

const Footer = ({ location }) => (
  <FooterWrapper>
    <FooterContainer>
      <img src={FooterLogo} alt="HP" className="logo" />
      {trailingSlashIt(location.pathname) !== '/login/' && (
        <ul>
          <li>
            <Link to="/terms">Terms & Conditions</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/contact-us">Contact Us</Link>
          </li>
          <li>
            <Link to="/faqs">FAQs</Link>
          </li>
          <li>
            <Link to="/sitemap">Sitemap</Link>
          </li>
        </ul>
      )}
      <p className="text--center footer-right-text">
        &copy; HP Rewards {new Date().getFullYear()}
      </p>
    </FooterContainer>
  </FooterWrapper>
);

Footer.propTypes = {
  siteName: PropTypes.string,
  location: PropTypes.object.isRequired,
};

Footer.defaultProps = {
  siteName: 'HP Rewards',
};

export default withSettings(Footer);
